var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsbusinessinsightstab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-26,.cls-30,.cls-32,.cls-33,.cls-34,.cls-5{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#d8c4df;}.cls-4{fill:#e7b7b7;}.cls-5{stroke:#565349;stroke-width:0.65px;}.cls-26,.cls-30,.cls-32,.cls-33,.cls-34,.cls-5{stroke-miterlimit:10;}.cls-27,.cls-6{fill:#2f2143;}.cls-7{fill:#f9f9fc;}.cls-8{fill:#fdc435;}.cls-9{fill:#1f3242;}.cls-10{fill:#966666;}.cls-11{fill:#e3a2a2;}.cls-12{mix-blend-mode:multiply;}.cls-13{clip-path:url(#clip-path);}.cls-14{fill:#9173b4;}.cls-15{clip-path:url(#clip-path-2);}.cls-16{fill:#9cbfe5;}.cls-17{opacity:0.6;}.cls-18{clip-path:url(#clip-path-3);}.cls-19{clip-path:url(#clip-path-4);}.cls-20{clip-path:url(#clip-path-5);}.cls-21{clip-path:url(#clip-path-6);}.cls-22{clip-path:url(#clip-path-7);}.cls-23{clip-path:url(#clip-path-8);}.cls-24{clip-path:url(#clip-path-9);}.cls-25{clip-path:url(#clip-path-10);}.cls-26,.cls-30,.cls-32,.cls-33,.cls-34{stroke:#2f2143;}.cls-26{stroke-width:1.48px;}.cls-27{font-size:35px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-28{fill:#ffc436;}.cls-29{fill:#9a499c;}.cls-30{stroke-width:0.9px;}.cls-31{fill:#ffc537;}.cls-32{stroke-width:1.45px;}.cls-33{stroke-width:1.02px;}.cls-34{stroke-width:0.73px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.87,
    y: 123.18,
    width: 40.22,
    height: 32.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.22,
    y: 138.65,
    width: 38.87,
    height: 17.35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.61,
    y: 103.92,
    width: 75.97,
    height: 58.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 63.71,
    y: 80.87,
    width: 26.18,
    height: 16.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.27,
    y: 117.34,
    width: 12.41,
    height: 11.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 155.88,
    y: 133.04,
    width: 43.33,
    height: 14.27
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 155.88,
    y: 133.04,
    width: 34.04,
    height: 14.27
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 150.19,
    y: 112.11,
    width: 58.53,
    height: 38.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.78,
    y: 55.39,
    width: 81.55,
    height: 37.09
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.02,
    y: 58.96,
    width: 15.48,
    height: 14.98
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "analytics &amp;amp; business insights tab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 765,
    height: 277
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.88,148.2c.2-.84,1.36-3.11-1.55-5.76-1.45-1.33-3.39-5.91-3.71-6.44-1-1.72-1.25-4.74-1.49-5.4-.11-.3,1.18-1.34,2.69,0a6.24,6.24,0,0,1,1.52,3.13c.26.9,1.67,3,2.37,2.88.89-.13,1.42-.61,1.52-1.82.26-3.09-3.62-13.24-3.22-14.13a1.51,1.51,0,0,1,2.77.23c.45,1.07,1.74,5.06,2.46,5,.44-.07.3-3.92.14-7.48a1.37,1.37,0,0,1,2.61-.79c.43,2.26.77,4.2,1.09,4.44s.46-1.6.6-2.07a1.32,1.32,0,0,1,2.54.1c.08.39.64,6.64,1.38,6.68.5,0,.45-2,.52-2.21.46-1.45,2.51-1.22,2.47.6,0,1.57-.13,8.41-.25,10.11A87.83,87.83,0,0,1,201,151.43Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M201,151.43c-2.22,10.41-3.93,49.09-11,51.73-7.23,2.72-23.54-8.37-23.54-8.37l7.75-19,6.12,4.74c2.1-11.21,8.56-32.35,8.56-32.35Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.32,180.55a35.75,35.75,0,0,0,0,11",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M192.32,135.94c4,1.31,5.67,5.66,5.67,5.66",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M192.24,125.79c.53,1.67,1.11,4.78,1.11,4.78",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M196.08,122c.53,3.83.75,8.61.75,8.61",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M200.6,126.67c.05,1.1,0,4.41,0,4.41",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66,148.2c-.2-.84-1.36-3.11,1.55-5.76C69,141.11,71,136.53,71.29,136c1-1.72,1.25-4.74,1.49-5.4.11-.3-1.18-1.34-2.69,0a6.24,6.24,0,0,0-1.52,3.13c-.26.9-1.67,3-2.37,2.88-.89-.13-1.42-.61-1.52-1.82-.26-3.09,3.62-13.24,3.22-14.13a1.51,1.51,0,0,0-2.77.23c-.45,1.07-1.74,5.06-2.46,5-.44-.07-.3-3.92-.14-7.48a1.37,1.37,0,0,0-2.61-.79c-.43,2.26-.77,4.2-1.09,4.44s-.46-1.6-.6-2.07a1.32,1.32,0,0,0-2.54.1c-.08.39-.64,6.64-1.38,6.68-.5,0-.45-2-.52-2.21-.46-1.45-2.51-1.22-2.47.6,0,1.57.13,8.41.25,10.11a87.83,87.83,0,0,0,2.36,16.26Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.93,151.43c2.22,10.41,3.93,49.09,11,51.73,7.23,2.72,23.54-8.37,23.54-8.37l-7.75-19-6.12,4.74C72.49,169.34,66,148.2,66,148.2Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M74.59,180.55a35.75,35.75,0,0,1,0,11",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62.59,135.94c-4,1.31-5.67,5.66-5.67,5.66",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M62.67,125.79c-.53,1.67-1.11,4.78-1.11,4.78",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.83,122c-.53,3.83-.75,8.61-.75,8.61",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.31,126.67c-.05,1.1,0,4.41,0,4.41",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.89,277c1.39-6.68,2.56-11.62,2.56-11.62L130.39,277h30.09l-3.15-37.87H97.58S95.48,259,94,277",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M147.88,156.82H107.16v83.62c13.27,3.88,40.72.93,40.72.93Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138.4,156.82c.51,5.92-2.94,11.42-10.94,11.42-11,0-11-11.42-11-11.42Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M123.39,171.31c3,10.54-1.29,74.86-1.29,74.86-16.64.71-26.36-3.75-26.36-3.75l4-53-13.91,9.38c-5.5-2.18-9-21.36-9-21.36s22.78-20.63,30.32-20.63h11.51c-9.33,6.6,4.72,14.49,4.72,14.49",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M131.65,171.31c-3,10.54,1.29,74.86,1.29,74.86,16.64.71,26.36-3.75,26.36-3.75l-4-53,13.91,9.38c5.5-2.18,9-21.36,9-21.36s-22.78-20.63-30.32-20.63H136.37c9.33,6.6-4.72,14.49-4.72,14.49",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.67,156.82l.41-4.22s-4,1.75-5.79,4.22,0,18.31,0,18.31,3.38-5,4.49-5.11,5.61,1.29,5.61,1.29-8.21-9.69-4.72-14.49",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M136.37,156.82l-.3-4.22s3.9,1.75,5.68,4.22,0,18.31,0,18.31-3.39-5-4.5-5.11-5.6,1.29-5.6,1.29,8.21-9.69,4.72-14.49",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.31,189.43c-.91-3.37-1.82-13.54-1.82-13.54",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.73,189.43c.46-4.51,1.57-14.77,1.57-14.77",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M107.8,127c1.6,5.34,3.57,6.91,7.62,8.57l19.07,8c5.63-6.09,6.75-8.91,6.75-17.18,3.59-7.21-1.12-18.76-8.56-16.55C126.2,99.45,97.17,113.36,107.8,127",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.41,159.37c.58,1.52,4.15,5.54,8.54,5.54,6.39,0,9.55-5.3,9.55-7.47L134.16,131l-13.61,2.76c.19,2-1.54,19.71-2.14,25.59",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M120,142.92l11-1.07s-.53,8.84-11.85,10Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.11,121.75c-2.64,4.2-.86,6.47-.86,10.65,0,4.48-1.71,10.83,1.88,14.15s12.33,3.59,18.22-3.84,4.6-20-1.87-23.26c-5.53-2.76-13.72-3.5-17.37,2.3",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M108.53,127c4.77.65,7.67-5.43,12.81-6.65a6.52,6.52,0,0,0,5.63,5.83c4.69,2.25,3.93,8.24,5.55,8.24.94,0,.86-4,1.67-5.31,3.35-5.34,1.37-10.89-4.44-13.47s-13-3.39-17.08,0S108.53,127,108.53,127",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M114.76,138.85c-2.05,0-2.46-.41-2.78-.95-.2-.33,0-1,.42-2.43a30.66,30.66,0,0,0,.81-3.17.24.24,0,0,1,.47.09,30.09,30.09,0,0,1-.82,3.21,8.81,8.81,0,0,0-.49,2c.22.37.45.75,2.39.75a.24.24,0,1,1,0,.47",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M128.2,133.53a2.29,2.29,0,1,1-3.21-1.21,2.42,2.42,0,0,1,3.21,1.21",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M118.77,130.34c0,.87-.42,1.58-.93,1.58s-.92-.71-.92-1.58.41-1.57.92-1.57.93.7.93,1.57",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M116.2,127.46c.19.66,1.85-.53,2.82-.43,1.65.16,1.71,1,2.31.84.08-.76-1-1.72-2.4-1.82a2.6,2.6,0,0,0-2.73,1.41",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M111.87,131c0,.73-.35,1.31-.77,1.31s-.77-.58-.77-1.31.35-1.3.77-1.3.77.58.77,1.3",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M112.24,128.4c0,.52-1.39,0-2,.26-1,.44-1,1.24-1.32,1.12A1.61,1.61,0,0,1,110,128a2,2,0,0,1,2.22.45",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M119.85,139.36a11.53,11.53,0,0,1-4.58,2.5,5.86,5.86,0,0,0,3.5.87c1.66-.29,1.08-3.37,1.08-3.37",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "43.59 155.99 35.74 155.99 32.87 123.18 40.71 123.18 43.59 155.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "59.05 155.99 51.2 155.99 49.33 134.59 57.18 134.59 59.05 155.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "73.09 155.99 65.24 155.99 64.24 144.58 72.09 144.58 73.09 155.99"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "43.59 155.99 35.74 155.99 34.22 138.65 42.07 138.65 43.59 155.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "59.05 155.99 51.2 155.99 50.7 150.29 58.55 150.29 59.05 155.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "73.09 155.99 65.24 155.99 64.5 147.55 72.35 147.55 73.09 155.99"
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "25.08 120.33 28.2 155.99 85.27 155.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M89,133.17a3.18,3.18,0,0,0-3.11-2.86,2.58,2.58,0,0,0-2.6,2.86,3.18,3.18,0,0,0,3.1,2.85A2.58,2.58,0,0,0,89,133.17",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M89.83,142.92a3.18,3.18,0,0,0-3.1-2.86,2.58,2.58,0,0,0-2.61,2.86,3.18,3.18,0,0,0,3.11,2.85,2.57,2.57,0,0,0,2.6-2.85",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M88.12,123.42a2.57,2.57,0,0,1-2.6,2.85,3.17,3.17,0,0,1-3.1-2.85,2.57,2.57,0,0,1,2.6-2.86,3.17,3.17,0,0,1,3.1,2.86",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M93,162.41H26.87A2.6,2.6,0,0,1,24.28,160l-4.66-53.29a2.6,2.6,0,0,1,2.59-2.83h66.1a2.61,2.61,0,0,1,2.6,2.38l4.66,53.28a2.61,2.61,0,0,1-2.6,2.83",
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "85.92 84.8 77.36 84.8 77.3 84.08 85.86 84.08 85.92 84.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "81.06 86.31 77.5 86.31 77.43 85.59 81 85.59 81.06 86.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "86.19 87.81 77.63 87.81 77.57 87.1 86.13 87.1 86.19 87.81"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M67.31,97.47h20a2.61,2.61,0,0,0,2.6-2.83l-1-11.39a2.61,2.61,0,0,0-2.59-2.38h-20a2.61,2.61,0,0,0-2.6,2.83l1,11.4a2.6,2.6,0,0,0,2.59,2.37",
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M74.53,92.55c.16,1.86-1.39,2.34-3.36,2.34s-3.61-.48-3.77-2.34a3.13,3.13,0,0,1,3.27-3.37,3.86,3.86,0,0,1,3.86,3.37",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M72.36,85.59A2.38,2.38,0,0,0,70,83.45a1.93,1.93,0,0,0-2,2.14,2.38,2.38,0,0,0,2.33,2.14,1.92,1.92,0,0,0,2-2.14",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "168.68 128.75 157.27 128.75 158.27 117.34 169.68 117.34 168.68 128.75"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "198.97 135.9 156.88 135.9 157.13 133.04 199.22 133.04 198.97 135.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "188.48 141.6 156.38 141.6 156.63 138.75 188.73 138.75 188.48 141.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "192.97 147.31 155.88 147.31 156.13 144.46 193.22 144.46 192.97 147.31"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "189.67 135.9 156.88 135.9 157.13 133.04 189.92 133.04 189.67 135.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "181.39 141.6 156.38 141.6 156.63 138.75 181.64 138.75 181.39 141.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "184.78 147.31 155.88 147.31 156.13 144.46 185.03 144.46 184.78 147.31"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "196.98 118.77 178.43 118.77 178.56 117.34 197.1 117.34 196.98 118.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "193.09 122.46 178.11 122.46 178.24 121.04 193.21 121.04 193.09 122.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "189.2 126.16 177.79 126.16 177.91 124.73 189.32 124.73 189.2 126.16"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M203.2,150.63H152.79a2.61,2.61,0,0,1-2.59-2.83l2.92-33.31a2.59,2.59,0,0,1,2.59-2.38h50.41a2.6,2.6,0,0,1,2.59,2.83l-2.91,33.31a2.61,2.61,0,0,1-2.6,2.38",
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M129.14,88.21h55.68c.52-10-.22-18-6-18-6.63,0-2.64,8.76-10.81,8.76-8.48,0-1.55-15.37-9.55-15.37-8.82,0-1.19,16.2-11.21,16.2-7.1,0-3.35-9.59-9.85-9.59-5.48,0-7.82,9.59-7.82,9.59Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M129.14,88.21h55.68c.52-10-.22-18-6-18-6.63,0-2.64,8.76-10.81,8.76-8.48,0-1.55-15.37-9.55-15.37-8.82,0-1.19,16.2-11.21,16.2-7.1,0-3.35-9.59-9.85-9.59-5.48,0-7.82,9.59-7.82,9.59Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M138.82,70.23a1.33,1.33,0,0,0-1.35-1.43,1.52,1.52,0,0,0-1.5,1.43,1.34,1.34,0,0,0,1.35,1.43,1.52,1.52,0,0,0,1.5-1.43",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M148.68,79.82a1.35,1.35,0,0,0-1.35-1.43,1.52,1.52,0,0,0-1.5,1.43,1.33,1.33,0,0,0,1.35,1.42,1.52,1.52,0,0,0,1.5-1.42",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M159.88,63.62a1.33,1.33,0,0,0-1.35-1.42,1.51,1.51,0,0,0-1.5,1.42,1.34,1.34,0,0,0,1.35,1.43,1.52,1.52,0,0,0,1.5-1.43",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M169.44,79a1.35,1.35,0,0,0-1.36-1.43,1.53,1.53,0,0,0-1.5,1.43,1.35,1.35,0,0,0,1.35,1.43A1.53,1.53,0,0,0,169.44,79",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M180.25,70.23a1.34,1.34,0,0,0-1.35-1.43,1.52,1.52,0,0,0-1.5,1.43,1.34,1.34,0,0,0,1.35,1.43,1.52,1.52,0,0,0,1.5-1.43",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "200.47 88.21 129.14 88.21 130.64 59.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "127.98 62.2 130.64 59.67 133.03 62.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "198.08 85.68 200.47 88.21 197.82 90.73"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M202.06,92.49H127.38a2.6,2.6,0,0,1-2.6-2.74l1.67-31.89a2.62,2.62,0,0,1,2.6-2.47h74.68a2.61,2.61,0,0,1,2.6,2.74L204.66,90a2.62,2.62,0,0,1-2.6,2.47",
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M201,60.8a1.9,1.9,0,0,1-1.87,1.79,1.67,1.67,0,0,1-1.69-1.79A1.9,1.9,0,0,1,199.31,59,1.67,1.67,0,0,1,201,60.8",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M200.71,66.41a1.9,1.9,0,0,1-1.88,1.78,1.68,1.68,0,0,1-1.69-1.78A1.9,1.9,0,0,1,199,64.62a1.68,1.68,0,0,1,1.69,1.79",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M200.42,72a1.92,1.92,0,0,1-1.88,1.79A1.68,1.68,0,0,1,196.85,72a1.9,1.9,0,0,1,1.88-1.78A1.68,1.68,0,0,1,200.42,72",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M41.9,73.94H32.14a2.6,2.6,0,0,1-2.6-2.47L29,61.7A2.6,2.6,0,0,1,31.63,59h9.76A2.6,2.6,0,0,1,44,61.43l.51,9.77a2.6,2.6,0,0,1-2.6,2.74",
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "31.66 65.44 35.91 69.48 41.66 63.42"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 249.76,
    cy: 42.62,
    r: 12.77
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-27",
    transform: "translate(283.07 145.29)"
  }, "ANALYTICS &amp;", /*#__PURE__*/React.createElement("tspan", {
    x: -46.2,
    y: 38
  }, "BUSINESS INSIGHTS")), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 591.47,
    cy: 77.57,
    r: 42.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M591.47,77.57q-2.81-20.88-5.59-41.78a42.82,42.82,0,0,1,22,2.9A41.87,41.87,0,0,1,621.58,48a41.1,41.1,0,0,1,6.47,8.69Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M591.47,77.57l30.92-28.72a42.45,42.45,0,0,1,10.3,19.66,43.51,43.51,0,0,1-3.05,26.87Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M701.68,216a27.38,27.38,0,1,1-27.38-27.38A27.38,27.38,0,0,1,701.68,216Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M662.8,240.81c-16.6-25,0-49.71,0-49.71",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M685.73,191.09s16.6,24.75,0,49.72",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M671.85,189.32s-17.13,29.39,0,53.48",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M676.94,189.32s17.14,29.28,0,53.38",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M697.2,200.94c-19.78,14.2-46.43,1-46.43,1l-3.86,11.63s28.91,14.48,54.67,0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M650.77,230s23.05,11.32,47.05,0",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M661.62,191.67s15.81,5.4,25.68,0",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M653.17,206c.76.21,1.52.41,2.29.6q.31,2.85.75,5.71c1.1-1.6,2.17-3.22,3.18-4.86l1.43.25c.37,1.87.78,3.74,1.25,5.61.93-1.66,1.83-3.34,2.68-5,.79.09,1.57.18,2.36.25q-2.18,4.56-4.75,9l-1.69-.25c-.48-1.9-.92-3.8-1.3-5.7-1,1.64-2.15,3.27-3.29,4.87-.55-.11-1.1-.24-1.65-.36-.56-3.37-1-6.75-1.26-10.11",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M667.41,208.51l2.35.17q.79,2.74,1.74,5.49c.8-1.78,1.55-3.56,2.26-5.36h1.44c.69,1.78,1.43,3.54,2.22,5.3q.93-2.72,1.74-5.43l2.36-.17q-1.32,4.88-3.07,9.72l-1.7.05c-.8-1.78-1.57-3.58-2.28-5.38-.74,1.8-1.52,3.6-2.36,5.38q-.84,0-1.68-.06-1.71-4.83-3-9.71",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M681.82,208.48c.78-.07,1.57-.16,2.35-.25q1.27,2.57,2.69,5.09c.47-1.89.9-3.78,1.27-5.67l1.43-.26c1,1.62,2.05,3.23,3.14,4.81.29-1.88.55-3.77.76-5.65q1.15-.28,2.31-.6-.45,5.06-1.31,10.12l-1.68.36c-1.11-1.61-2.19-3.24-3.22-4.88-.4,1.9-.86,3.81-1.36,5.71-.56.09-1.11.17-1.67.24q-2.55-4.44-4.71-9",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M403.25,66l-10.13-5.48-2.28,4.95a1.67,1.67,0,0,1-2.76.41L369.15,44.5a1.66,1.66,0,0,1,1.2-2.77L399.5,41a1.67,1.67,0,0,1,1.55,2.37L398.42,49l11.31,4.37a2,2,0,0,1,1,2.79l-4.82,9a2,2,0,0,1-2.7.81",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 714.03,
    cy: 38.25,
    r: 12.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 274.99,
    cy: 246.25,
    r: 8.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 510.79,
    cy: 226.31,
    r: 6.32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsbusinessinsightstab);
export default __webpack_public_path__ + "static/media/analytics & business insights tab.f97823356ed6b81510b5233787a5dcaf.svg";
export { ForwardRef as ReactComponent };